import React, { useCallback, useMemo } from "react"
import styled from "styled-components"
import { addElement, removeElementById } from "../../../globalStates/utils"
import { EMPTY_NEWS, useExhibitorDataState } from "../../../globalStates/ExhibitorDataState"
import { addValidatorsNews } from "../../../globalStates/ExhibitorValidation"
import { useLanguageState } from "../../../globalStates/LanguageState"
import { useConfigDataState } from "../../../globalStates/ConfigDataState"
import { newId } from "../../../utils/Id"
import Page from "../../../components/Page"
import Button from "../../../components/Button"
import NewsSection from "../NewsSection"
import { News } from "../../../globalStates/ExhibitorDataTypes"

const ButtonsBar = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`

const StoryNewsPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const newsLimit = serviceKeys.news || 0

    const newsStates = useExhibitorDataState().getStoryNews()
    const isMonoLingual = branding.configuration.monoLingual

    const canAddNews = useMemo(() => {
        if (newsStates.length >= newsLimit) return false
        let valid = true
        newsStates.forEach((newState) => {
            const name = newState.name.get()
            const nameDe = newState.nameDe.get()
            isMonoLingual ? (valid = valid && !!nameDe && nameDe.length >= 0) : (valid = valid && !!name && name.length >= 0)
        })
        return valid
        // eslint-disable-next-line
    }, [newsLimit, isMonoLingual])

    const onAddNews = useCallback(() => {
        addElement<News>(newsStates, { ...EMPTY_NEWS, id: newId().toString(), medias: [], type: "STORY" })
        addValidatorsNews(newsStates[newsStates.length - 1])
    }, [newsStates])

    const onRemoveNews = useCallback(
        (newsId: string) => {
            removeElementById<News>(newsStates, newsId)
        },
        [newsStates]
    )

    return (
        <Page
            title={branding.configuration.storyNewsPage.pageTitle}
            description={branding.configuration.storyNewsPage.pageDescription}
        >
            {newsStates?.map((newsState, index) => (
                <NewsSection
                    key={newsState.id.get()}
                    newsState={newsState}
                    index={index}
                    onClickRemove={onRemoveNews}
                    categoryWhitelist={branding.configuration.storyNewsPage.categoryWhitelist}
                />
            ))}

            <ButtonsBar>
                <Button
                    id="addNews"
                    caption={branding.configuration.storyNewsPage.btnAddNews}
                    inverse
                    onClick={onAddNews}
                    disabled={!canAddNews}
                />
            </ButtonsBar>
        </Page>
    )
}

export default StoryNewsPage
